<section class="page">
  <header class="page-header">
    <h2>Retard de livraison de cartouches</h2>
    <p class="subtitle">Liste les cartouches non encore livrées 10 jours après la date d'envoi de leur capteur.</p>
  </header>

  <section class="panel">
    <div class="actions-row">
      <button type="button" (click)="refresh()" [disabled]="loading">
        {{ loading ? 'Chargement...' : 'Actualiser la liste' }}
      </button>
      <a class="action-link" routerLink="/intranet/gestion-stocks/cartouches/voir">Aller vers cartouches</a>
    </div>

    @if (error) {
      <p class="error">{{ error }}</p>
    }

    @if (loading) {
      <p class="meta">Chargement des cartouches en retard...</p>
    } @else if (items.length === 0) {
      <p class="meta">Aucune cartouche en retard de livraison.</p>
    } @else {
      <p class="meta">{{ items.length }} cartouche(s) en retard.</p>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nom</th>
              <th>Capteur n° de série</th>
              <th>Date d'envoi du capteur</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item.id) {
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.nom }}</td>
                <td>{{ item.capteur_numero_serie }}</td>
                <td>{{ item.date_envoi ? (item.date_envoi | date: 'dd/MM/yyyy') : '-' }}</td>
                <td>{{ item.statut_livraison_nom || '-' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </section>
</section>
